// Generated by Melange

import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__GrpcItemsTable from "../../../molecules/ItemsTable/GrpcItemsTable.js";
import * as Buhta_cabinet__ItemsListLayout from "../../../molecules/ItemsTable/ItemsListLayout.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__Toggle from "../../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function CredentialList(Props) {
  let onItemClick = Props.onItemClick;
  const columns_0 = {
    title: "ID",
    content: (function (model) {
      return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
        route: {
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Keychain */ 0,
            _0: {
              TAG: /* Credentials */ 1,
              _0: {
                TAG: /* View */ 0,
                _0: model.id
              }
            }
          }
        },
        className: "inline-flex space-x-2 items-center justify-between group text-left",
        children: [
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            children: String(model.id)
          }),
          JsxRuntime.jsx("img", {
            className: "w-4 h-4 text-gray-500 group-hover:text-cool-gray-900",
            src: StaticAsset.src("/static/icons/eye.svg")
          })
        ]
      });
    }),
    textAlign: "left",
    fillWidth: false
  };
  const columns_1 = {
    hd: {
      title: "Предприятие",
      content: (function (model) {
        const org = model.org;
        if (org !== undefined) {
          return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: {
              TAG: /* Admin */ 7,
              _0: {
                TAG: /* Orgs */ 1,
                _0: {
                  TAG: /* Org */ 0,
                  _0: org.id,
                  _1: /* Dashboard */ 0
                }
              }
            },
            children: JsxRuntime.jsx("p", {
              children: org.name,
              className: "text-primary hover:text-primary-lite"
            })
          });
        } else {
          return null;
        }
      }),
      textAlign: "left",
      fillWidth: false
    },
    tl: {
      hd: {
        title: "Название",
        content: (function (model) {
          return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            children: model.name
          });
        }),
        textAlign: "left",
        fillWidth: false
      },
      tl: {
        hd: {
          title: "Логин",
          content: (function (model) {
            return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              children: model.username !== "" ? model.username : "—"
            });
          }),
          textAlign: "left",
          fillWidth: false
        },
        tl: {
          hd: {
            title: "Пароль",
            content: (function (model) {
              return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: model.password !== "" ? model.password : "—"
              });
            }),
            textAlign: "left",
            fillWidth: false
          },
          tl: {
            hd: {
              title: "Пометка",
              content: (function (model) {
                return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: model.memo !== "" ? model.memo : "—"
                });
              }),
              textAlign: "left",
              fillWidth: false
            },
            tl: {
              hd: {
                title: "Тег",
                content: (function (model) {
                  return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    children: model.tag
                  });
                }),
                textAlign: "left",
                fillWidth: false
              },
              tl: {
                hd: {
                  title: "Сайт",
                  content: (function (model) {
                    return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      children: model.website
                    });
                  }),
                  textAlign: "left",
                  fillWidth: false
                },
                tl: {
                  hd: {
                    title: "Истекает",
                    content: (function (model) {
                      const expireDate = model.expire_date;
                      if (expireDate === undefined) {
                        return "—";
                      }
                      const expireDateStr = Buhta_cabinet__Date.toString(expireDate);
                      const daysLeft = DateTime.daysLeft(DateTime.fromDateFormat(expireDateStr));
                      return JsxRuntime.jsx("span", {
                        children: expireDateStr,
                        className: Cn.fromList({
                          hd: "inline-flex items-center px-2.5 py-0.5 rounded-full leading-4 capitalize",
                          tl: {
                            hd: daysLeft < 7 ? "bg-pink-100 text-pink-700" : (
                                daysLeft < 14 ? "bg-orange-100 text-orange-700" : (
                                    daysLeft < 30 ? "bg-yellow-100 text-yellow-700" : ""
                                  )
                              ),
                            tl: /* [] */ 0
                          }
                        })
                      });
                    }),
                    textAlign: "left",
                    fillWidth: false
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const columns = {
    hd: columns_0,
    tl: columns_1
  };
  const match = React.useState(function () {
    return false;
  });
  const setIsDetailed = match[1];
  const isDetailed = match[0];
  const match$1 = React.useState(function () {
    return /* [] */ 0;
  });
  const setExpand = match$1[1];
  const match$2 = React.useState(function () {
    
  });
  const setSearchText = match$2[1];
  const searchText = match$2[0];
  const match$3 = React.useState(function () {
    return 1;
  });
  const page = match$3[0];
  React.useEffect((function () {
    Curry._1(setExpand, (function (param) {
      if (isDetailed) {
        return {
          hd: "username",
          tl: {
            hd: "password",
            tl: {
              hd: "memo",
              tl: /* [] */ 0
            }
          }
        };
      } else {
        return /* [] */ 0;
      }
    }));
  }), [isDetailed]);
  const match$4 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Keychain.CredentialService.grid, undefined);
  const dispatch = match$4[1];
  React.useEffect((function () {
    const params = {
      search: searchText,
      page: page,
      filters: /* [] */ 0,
      expand: /* [] */ 0
    };
    Curry._3(dispatch, undefined, params, undefined);
  }), [
    searchText,
    page,
    match$1[0]
  ]);
  return JsxRuntime.jsx(Buhta_cabinet__ItemsListLayout.make, {
    createAction: {
      TAG: /* Link */ 0,
      _0: {
        TAG: /* Admin */ 7,
        _0: {
          TAG: /* Keychain */ 0,
          _0: {
            TAG: /* Credentials */ 1,
            _0: /* Create */ 1
          }
        }
      }
    },
    onSearch: (function (text) {
      Curry._1(setSearchText, (function (param) {
        return text;
      }));
    }),
    actions: {
      hd: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            children: "Детально"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
            checked: isDetailed,
            onChange: (function (value) {
              Curry._1(setIsDetailed, (function (param) {
                return value;
              }));
            })
          })
        ],
        className: "flex items-center space-x-2"
      }),
      tl: /* [] */ 0
    },
    children: JsxRuntime.jsx(Buhta_cabinet__GrpcItemsTable.make, {
      columns: columns,
      items: match$4[0],
      clickable: !isDetailed,
      onItemClick: (function (item) {
        if (isDetailed) {
          return;
        } else {
          return Curry._1(onItemClick, item);
        }
      })
    })
  });
}

const make = CredentialList;

export {
  make,
}
/* Buhta_cabinet__Date Not a pure module */
